/*
 * Клиент бэкенд-плагина jupyterhub (packages/backend/src/modules/jupyterhub.ts): серверы
 * пользователей хаба кластера. Кластер — из аннотации viva.company.com/cluster сущности
 * jupyterhub-<кластер>; адрес хаба бэкенд находит по каталогу сам.
 */
import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';

export type JupyterServer = {
  user: string;
  name: string;
  ready: boolean;
  pending: string | null;
  started: string | null;
  lastActivity: string | null;
  profile?: string;
  url: string;
};

export type JupyterHubUsers = {
  cluster: string;
  hubUrl: string;
  users: {
    name: string;
    admin: boolean;
    lastActivity: string | null;
    servers: number;
  }[];
  servers: JupyterServer[];
  summary: { users: number; running: number; pending: number };
};

export type JupyterHubInfo = {
  hubUrl: string;
  version?: string;
  python?: string;
  authenticator?: string;
  spawner?: string;
};

export interface JupyterHubApi {
  getUsers(cluster: string): Promise<JupyterHubUsers>;
  getInfo(cluster: string): Promise<JupyterHubInfo>;
}

export const jupyterhubApiRef = createApiRef<JupyterHubApi>({
  id: 'plugin.viva.jupyterhub',
});

export class JupyterHubApiClient implements JupyterHubApi {
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  getUsers(cluster: string): Promise<JupyterHubUsers> {
    return this.request(`/clusters/${encodeURIComponent(cluster)}/users`);
  }

  getInfo(cluster: string): Promise<JupyterHubInfo> {
    return this.request(`/clusters/${encodeURIComponent(cluster)}/info`);
  }

  private async request<T>(path: string): Promise<T> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl('jupyterhub');
    const response = await this.options.fetchApi.fetch(`${baseUrl}${path}`);
    if (!response.ok) {
      const payload = await response.json().catch(() => ({}));
      throw new Error(
        payload?.error?.message ??
          `JupyterHub request failed with status ${response.status}`,
      );
    }
    return (await response.json()) as T;
  }
}
